"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSchool = void 0;
var slugify_1 = require("slugify");
var account_1 = require("../account");
var interfaces_1 = require("./interfaces");
var school_participant_1 = require("./school-participant");
var dateProperties = ['created_at', 'updated_at'];
var CSchool = /** @class */function () {
  function CSchool(values) {
    var instance = this;
    if (!values) {
      return instance;
    }
    for (var _i = 0, _a = Object.keys(values); _i < _a.length; _i++) {
      var key = _a[_i];
      var _key = key;
      var _value = values[_key];
      if (dateProperties.includes(_key)) {
        instance[_key] = new Date(_value);
      } else {
        instance[_key] = _value;
      }
    }
    if ('owners' in values) {
      instance.owners = values.owners.map(function (p) {
        return new school_participant_1.CSchoolParticipant(p);
      });
    }
    if ('teachers' in values) {
      instance.teachers = values.teachers.map(function (p) {
        return new school_participant_1.CSchoolParticipant(p);
      });
    }
    // TODO удалить
    if ('participants' in values) {
      instance.participants = values.participants.map(function (p) {
        return new school_participant_1.CSchoolParticipant(p);
      });
    }
    if ('slug' in values && 'title' in values) {
      instance.urlPart = (0, slugify_1.default)(values.title, {
        lower: true,
        strict: true
      }) + "-".concat(values.slug);
    }
    if ('options' in values) {
      instance.options = new interfaces_1.SchoolOptions(values.options);
    }
    return this;
  }
  Object.defineProperty(CSchool.prototype, "accountable_type", {
    /** Тип для банковских рассчётов. Всегда имеет значение EAccountableType.school */
    get: function () {
      return account_1.EAccountableType.school;
    },
    enumerable: false,
    configurable: true
  });
  return CSchool;
}();
exports.CSchool = CSchool;
